import { render, staticRenderFns } from "./LeilaoCard.vue?vue&type=template&id=485a7b1a&scoped=true"
import script from "./LeilaoCard.vue?vue&type=script&lang=js"
export * from "./LeilaoCard.vue?vue&type=script&lang=js"
import style0 from "./LeilaoCard.vue?vue&type=style&index=0&id=485a7b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a7b1a",
  null
  
)

export default component.exports